export enum OrderDirection {
  Bids = 66,
  Offers = 83,
}
